/**
 * Pseudo des élèves (migrations 0661-0663) : le nom public d'un élève est un
 * pseudo (« LoutreAgile27 ») ; son vrai nom, protégé, n'est montré qu'à lui,
 * ses profs et ses parents. Règles du formulaire « Mon profil ». PUR, testé.
 */

import { supabase } from '@/lib/supabase';

export const PSEUDO_MIN = 3;
export const PSEUDO_MAX = 24;

/** Problème bloquant du pseudo saisi, sinon null. */
export function pseudoIssue(pseudo: string, realName?: string | null): string | null {
  const p = pseudo.trim();
  if (p.length < PSEUDO_MIN || p.length > PSEUDO_MAX)
    return `Ton pseudo fait entre ${PSEUDO_MIN} et ${PSEUDO_MAX} caractères.`;
  if (realName && p.toLowerCase() === realName.trim().toLowerCase())
    return 'Ton pseudo ne peut pas être ton vrai nom : choisis-en un autre.';
  return null;
}

/** Message lisible pour une erreur d'enregistrement du profil. */
export function profileSaveErrorMessage(message: string): string {
  if (message.includes('pseudo_is_real_name'))
    return 'Ton pseudo ne peut pas être ton vrai nom : choisis-en un autre.';
  return message || 'Une erreur est survenue.';
}

type UntypedRpc = (
  name: string,
  params?: Record<string, unknown>,
) => Promise<{ data: unknown; error: { message: string } | null }>;

/** Un nouveau pseudo proposé par le serveur (non enregistré). */
export async function suggestPseudo(): Promise<string | null> {
  const { data, error } = await (supabase.rpc as unknown as UntypedRpc)('suggest_student_pseudo');
  if (error) return null;
  return typeof data === 'string' ? data : null;
}
